import { createClient } from '@supabase/supabase-js'

const url = import.meta.env.VITE_SUPABASE_URL
const key = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY
const canonicalOrigin = 'https://portal.warrenpolice.com'

export function authRedirectOrigin() {
  const local = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
  return local ? window.location.origin : canonicalOrigin
}

export const isSupabaseConfigured = Boolean(url && key && !url.includes('your-project'))
export const supabase = isSupabaseConfigured ? createClient(url!, key!, { auth: { persistSession: true, detectSessionInUrl: true } }) : null

export async function signInWithMicrosoft() {
  if (!supabase) throw new Error('Supabase is not configured')
  return supabase.auth.signInWithOAuth({
    provider: 'azure',
    options: { scopes: 'email', redirectTo: authRedirectOrigin() },
  })
}
